import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {AuthenticationFormFactory} from '../../../authentication/factories/authentication-form.factory';
import {MatIconModule} from '@angular/material/icon';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatButtonModule} from '@angular/material/button';
import {IconButtonComponent} from '../../../../shared/components/icon-button/icon-button.component';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {AuthenticationService} from '../../../authentication/authentication.service';
import {LoginResponseDto} from '../../../authentication/dtos/login-response.dto';
import {MemoryService} from '../../../../core/services/memory.service';
import {Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorService} from '../../../../core/services/error.service';

@Component({
  selector: 'app-manager-login',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, TranslocoPipe, MatButtonModule, IconButtonComponent, TextButton],
  templateUrl: './manager-login.dialog.html',
  styleUrl: './manager-login.dialog.scss'
})
export class ManagerLoginDialog implements OnInit {
  dialogRef = inject(MatDialogRef<ManagerLoginDialog>);
  fb: FormBuilder = inject(FormBuilder);
  authenticationService: AuthenticationService = inject(AuthenticationService);
  memoryService: MemoryService = inject(MemoryService);
  translocoService = inject(TranslocoService);
  router: Router = inject(Router);
  dialog: MatDialog = inject(MatDialog);
  errorService: ErrorService = inject(ErrorService);
  loginForm!: FormGroup;
  hidePassword: boolean = true;
  error?: string;

  ngOnInit(): void {
    this.loginForm = AuthenticationFormFactory.createLoginForm(this.fb);
  }

  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }

  login() {
    this.loginForm.markAllAsTouched();
    if (this.loginForm.invalid) {
      return;
    }

    let loginRequestDto = this.loginForm.value;
    loginRequestDto.locationId = this.memoryService.locationId ?? 0;
    loginRequestDto.customerId = this.memoryService.customerId ?? 0;
    this.authenticationService.loginAsManager(loginRequestDto).subscribe({
      next: (loginResponseDto: LoginResponseDto) => {
        this.error = undefined;
        this.memoryService.accessToken = loginResponseDto.accessToken;
        this.memoryService.refreshToken = loginResponseDto.refreshToken;
        this.memoryService.patientId = 0;
        this.memoryService.isNewUser = false;
        this.memoryService.isPatientManager = true;
        this.dialogRef.close(true);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.error = this.translocoService.translate('login.error.unauthorized');
          return;
        }

        this.error = undefined;
        this.errorService.handleError(error, this.translocoService.translate('error.title.login'));
      }
    })
  }
}
